import { put, takeEvery, all, call } from "redux-saga/effects";
import {
  FETCH_DATA_TAG_DASHBOARD_DATA,
  SET_DATA_ESTATE,
  SET_DATA_TAG_FILE_CLASSIFICATIONS,
  SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA,
  SET_DATA_TAG_DUPLICATE_FILE_DATA,
  SET_DATA_TAG_METADATA,
  SET_DATA_TAG_LOADING,
  fetchDataEstateAPI,
  fetchDataTagFileClassificationsAPI,
  fetchDataTagSensitiveAndRegulatedDataAPI,
  fetchDataTagDuplicateFileDataAPI,
  fetchDataTagMetadataAPI,
  fetchTotalDataTagFilesAPI,
  SET_TOTAL_DATA_TAG_FILES,
  fetchDataTagAllFilesAPI,
  SET_DATA_TAG_ALL_FILES,
  FETCH_DATA_TAG_ALL_FILES,
  SET_ALL_DATA_TAG_SOURCES,
  FETCH_ALL_DATA_SOURCES_API_DATA_TAG,
  fetchDataTagUsersAPI,
  FETCH_DATA_TAG_USERS,
  SET_DATA_TAG_USERS,
  FETCH_DATA_ESTATE_SUMMARY,
  SET_DATA_ESTATE_SUMMARY,
  fetchDataEstateSummaryAPI,
  SET_DATA_TAG_DRIVES,
  fetchDataTagDrivesAPI,
  FETCH_DATA_TAG_DRIVES,
  fetchDataTagDataAccessibilityAPI,
  SET_DATA_TAG_ACCESSIBILITY,
  SEARCH_DATA_TAG_FILES,
  SET_SEARCHED_DATA_TAG_FILES,
  FETCH_DATA_TAG_FILES,
  SET_SEARCHED_DATA_TAG_USERS,
  FETCH_DATA_TAG_USERS_LIST,
  FETCH_SIZE_CARD_DATA,
  SET_SIZE_CARD_DATA,
  FETCH_SENSITIVE_SUMMARY_CARD_DATA,
  SET_SENSITIVE_SUMMARY_CARD_DATA,
  FETCH_CATEGORY_CARD_DATA,
  SET_CATEGORY_CARD_DATA,
  DATA_ESTATE_SUMMARY_LOADER,
  FETCH_ALL_FILE_TYPES_DATA,
  SET_ALL_FILE_TYPE_LIST,
  fetchAllFileTypes,
  DATA_TAG_DUPLICATE_DRIVE_DATA,
  fetchDataTagDuplicateDriveDataAPI,
  SET_DATA_TAG_DUPLICATE_DRIVE_DATA,
  fetchDataTagDuplicateUserDataAPI,
  SET_DATA_TAG_DUPLICATE_USER_DATA,
  DATA_TAG_DUPLICATE_USER_DATA,
  SET_DATA_TAG_DUPLICATE_USER_DATA_2,
  fetchDataTagDuplicateUserDataAPI_2,
  DATA_TAG_DUPLICATE_USER_DATA_2,
  fetchDataTagDuplicateDriveFileDataAPI,
  SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA,
  DATA_TAG_DUPLICATE_FILE_DATA,
  SET_DATA_TAG_POPUP_LOADER,
  fetchDataTagDuplicateDriveFileDataAPI_2,
  SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA_2,
  DATA_TAG_DUPLICATE_FILE_DATA_2,
  fileMapUrl,
  SET_FILE_MAP_DATA,
  GET_FILE_MAP_DATA,
  userFilterList,
  SET_USERS_LIST,
  FETCH_USERS_LIST,
  fileFilterList,
  SET_FILES_LIST,
  FETCH_FILES_LIST,
} from "./DataTagConstants";
import { getAxiosHeaders, getService } from "../../library/RestAPI";
import {
  cubejsApi,
  getCubejsApi,
  redirectToLogin,
} from "../../components/common/Dashboard/cubejs-util";
import {
  DATASOURCE_URL,
  SEARCH_DB_USER_URL,
} from "../../redux/constants/constants";


function* fetchData(apiUrl) {
  const options = {
    method: "GET",
    url: apiUrl,
    headers: getAxiosHeaders(true),
  };

  const response = yield call(getService, options);
  return response;
}


function* getDataTagDashboardDataSaga() {
  try {

    yield put({ type: SET_DATA_TAG_LOADING, payload: true });

    const [
      totalFilesRes,
      dataEstateRes,
      fileClassificationsRes,
      sensitiveRegulatedRes,
      duplicateFileRes,
      metadataRes,
      DataAccessibilityRes,
    ] = yield all([
      call(fetchData, fetchTotalDataTagFilesAPI),
      call(fetchData, fetchDataEstateAPI),
      call(fetchData, fetchDataTagFileClassificationsAPI),
      call(fetchData, fetchDataTagSensitiveAndRegulatedDataAPI),
      call(fetchData, fetchDataTagDuplicateFileDataAPI),
      call(fetchData, fetchDataTagMetadataAPI),
      call(fetchData, fetchDataTagDataAccessibilityAPI),
    ]);

    // Dispatch successful results
    if (totalFilesRes?.status === 200)
      yield put({
        type: SET_TOTAL_DATA_TAG_FILES,
        payload: totalFilesRes.data,
      });

    if (dataEstateRes?.status === 200)
      yield put({ type: SET_DATA_ESTATE, payload: dataEstateRes.data });

    if (fileClassificationsRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_FILE_CLASSIFICATIONS,
        payload: fileClassificationsRes.data,
      });

    if (sensitiveRegulatedRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA,
        payload: sensitiveRegulatedRes?.data,
      });

    if (duplicateFileRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_DUPLICATE_FILE_DATA,
        payload: duplicateFileRes.data,
      });

    if (metadataRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_METADATA,
        payload: metadataRes.data,
      });
    if (DataAccessibilityRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_ACCESSIBILITY,
        payload: DataAccessibilityRes.data,
      });
  } catch (error) {
    console.error("Data Tag Dashboard Saga Error:", error);
    redirectToLogin(error);
  } finally {
    // Stop loader
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
  }
}

function* fetchDataTagAllFiles(action) {
  yield put({ type: SET_DATA_TAG_LOADING, payload: true });
  const {
    dataSourceId,
    page,
    size,
    fileNames,
    sensitivity,
    usernames,
    category,
    regulations,
    types,
    extensions,
  } = action.payload;

  let paramData = {};
  let sensitivityFilter = "";
  let fileNameFilter = "";
  let usernameFilter = "";
  let categoryFilter = "";
  let regulationsFilter = "";
  let typesFilter = "";
  let extensionFilter = "";
  
  if (regulations && regulations.length > 0) {
    regulationsFilter = regulations.join(",");
    paramData["regulations"] = regulationsFilter;
  }

 if (sensitivity && sensitivity.length > 0) {
   const mappedSensitivity = sensitivity.map((item) =>
     item === "NO_SENSITIVITY" ? "NOT_PROCESSED" : item,
   );

   sensitivityFilter = mappedSensitivity.join(",");
   paramData["sensitivity"] = sensitivityFilter;
 }
  if (fileNames && fileNames.length > 0) {
    fileNameFilter = fileNames.join(",");
    paramData["fileName"] = fileNameFilter;
  }
  if (usernames && usernames.length > 0) {
    usernameFilter = usernames.join(",");
    paramData["owner"] = usernameFilter;
  }
  if (category && category.length > 0) {
    categoryFilter = category.join(",");
    paramData["category"] = categoryFilter;
  }
  if (types && types.length > 0) {
    typesFilter = types.join(",");
    paramData["fileTypes"] = typesFilter;
  }
  if (extensions && extensions.length > 0) {
    extensionFilter = extensions.join(",");
    paramData["extensions"] = extensionFilter;
  }
  const options = {
    method: "GET",
    url: `${fetchDataTagAllFilesAPI(dataSourceId)}&page=${page}&size=${size}`,
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_DATA_TAG_ALL_FILES,
        payload: {
          content: response.data?.content,
          totalCount: response.data?.totalElements,
        },
      });
      yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (error) {
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    console.error("Error fetching all data tag files:", error);
    redirectToLogin(error);
  }
}

function* fetchAllDataSourcesAPIDataTag(action) {
  const { page, size } = action.payload;
  const options = {
    method: "GET",
    url: `${DATASOURCE_URL}?size=${size}&page=${page}`,
    headers: getAxiosHeaders(true),
    data: {},
  };
  try {
    const response = yield call(getService, options);
    if (response && response.status === 200) {
      yield put({
        type: SET_ALL_DATA_TAG_SOURCES,
        payload: response.data?.content.filter(
          (item) => item?.type?.code !== "ENTRA"
        ),
      });
    } else {
      console.error("Error Fetching Data.");
    }
  } catch (error) {
    console.error("Error fetching all data sources:", error);
  }
}

function* fetchDataTagUsers(action) {
  yield put({ type: SET_DATA_TAG_LOADING, payload: true });

  const { dataSourceId, page, size, usernames, sensitivity } = action.payload;

  let paramData = {};
  if (usernames?.length) {
    paramData["userName"] = usernames.join(",");
  }
  let sensitivityFilter = "";
  if (sensitivity && sensitivity.length > 0) {
   const mappedSensitivity = sensitivity.map((item) =>
     item === "NO_SENSITIVITY" ? "NOT_PROCESSED" : item,
   );

   sensitivityFilter = mappedSensitivity.join(",");
   paramData["category"] = sensitivityFilter;
 }

  const options = {
    method: "GET",
    url: `${fetchDataTagUsersAPI(dataSourceId)}&page=${page}&size=${size}`,
    params: paramData,
    headers: getAxiosHeaders(true),
  };

  try {
    const response = yield call(getService, options);

    if (response?.status === 200) {
      const transformed = response.data?.content?.map((item) => {
        const {
          criticalSensitivityFiles,
          highSensitivityFiles,
          mediumSensitivityFiles,
          lowSensitivityFiles,
          notProcessedFiles,
          noRiskFiles,
          noOfFiles,
          ...rest
        } = item;

        return {
          ...rest,
          noOfFiles,

          sensitivityData: {
            sensitivity_count_critical: criticalSensitivityFiles || 0,
            sensitivity_count_high: highSensitivityFiles || 0,
            sensitivity_count_medium: mediumSensitivityFiles || 0,
            sensitivity_count_low: lowSensitivityFiles || 0,
            sensitivity_count_no_risk: noRiskFiles || 0,
            sensitivity_count_not_processed: notProcessedFiles || 0,
            total_sensitivity_count: noOfFiles || 0,
          },
        };
      });

      yield put({
        type: SET_DATA_TAG_USERS,
        payload: {
          content: transformed,
          totalCount: response.data?.totalElements,
        },
      });

      yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (error) {
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    console.error("Error fetching data tag users:", error);
    redirectToLogin(error);
  }
}

function* fetchDataEstateDrives(action) {
  yield put({ type: SET_DATA_TAG_LOADING, payload: true });
  const { dataSourceId, page, size, category, sensitivity } = action.payload;
  let paramData = {};
  let sensitivityFilter = "";
  let categoryFilter = "";
   if (sensitivity && sensitivity.length > 0) {
   const mappedSensitivity = sensitivity.map((item) =>
     item === "NO_SENSITIVITY" ? "NOT_PROCESSED" : item,
   );

   sensitivityFilter = mappedSensitivity.join(",");
   paramData["sensitivity"] = sensitivityFilter;
 }
  if (category && category.length > 0) {
    categoryFilter = category.join(",");
    paramData["fileType"] = categoryFilter;
  }
  const options = {
    method: "GET",
    url: `${fetchDataTagDrivesAPI(dataSourceId)}&page=${page}&size=${size}`,
    params: paramData,
    headers: getAxiosHeaders(true),  
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DRIVES,
        payload: response.data || [],
      });
      yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (error) {
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    console.error("Error fetching data estate drives:", error);
    redirectToLogin(error);
  }
}

function* fetchDataEstateSummary(action) {
  yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: true });
  const { dataSourceId } = action.payload;
  const options = {
    method: "GET",
    url: fetchDataEstateSummaryAPI(dataSourceId),
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_DATA_ESTATE_SUMMARY,
        payload: response.data?.content[0],
      });
      yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
    }
  } catch (error) {
    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
    console.error("Error fetching data estate summary:", error);
    redirectToLogin(error);
  }
}

function* searchDataTagFiles(action) {
  const { fileName } = action.payload;
  const options = {
    method: "GET",
    url: SEARCH_DATA_TAG_FILES,
    headers: getAxiosHeaders(true),
    params: {
      query: fileName === "" ? " " : fileName,
    },
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_SEARCHED_DATA_TAG_FILES,
        payload: response.data?.content || [],
      });
    }
  } catch (error) {
    console.error("Error searching data tag files:", error);
    redirectToLogin(error);
  }
}

function* searchDataTagUsers(action) {
  const { userName } = action.payload;
  const options = {
    method: "GET",
    url: SEARCH_DB_USER_URL,
    headers: getAxiosHeaders(true),
    params: {
      queryString: userName === "" ? " " : userName,
    },
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_SEARCHED_DATA_TAG_USERS,
        payload: response.data?.content || [],
      });
    }
  } catch (error) {
    console.error("Error searching data tag users:", error);
    redirectToLogin(error);
  }
}

function* fetchSizeCardData(action) {
  const dataSourceId = action.payload;

  yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: true });

  const cubejsApi = getCubejsApi();

  const totalCount = {
    measures: ["DataTagSensitivity.count"],
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  const sizeData = {
    measures: ["DataTagSensitivity.fileSizeTotal"],
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  const pdaData = {
    measures: ["DataTagPDA.publicAccessCheckedCount"],
    filters: [
      {
        member: "DataTagPDA.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  const regulatedData = {
    measures: ["DataTagSensitivity.regulatedCount"],
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  const sensitivityData = {
    measures: ["DataTagSensitivity.count"],
    filters: [
      {
        member: "DataTagSensitivity.category",
        operator: "notEquals",
        values: ["NOT_PROCESSED"],
      },
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  try {
    const [sizeRes, pdaRes, regulatedRes, sensitivityRes, totalCountRes] = yield all([
      call([cubejsApi, cubejsApi.load], sizeData),
      call([cubejsApi, cubejsApi.load], pdaData),
      call([cubejsApi, cubejsApi.load], regulatedData),
      call([cubejsApi, cubejsApi.load], sensitivityData),
      call([cubejsApi, cubejsApi.load], totalCount),
    ]);

    const size = sizeRes.rawData();
    const publicAccess = pdaRes.rawData();
    const regulated = regulatedRes.rawData();
    const sensitivity = sensitivityRes.rawData();
    const totalFilesCount = totalCountRes.rawData();

    yield put({
      type: SET_SIZE_CARD_DATA,
      payload: {
        size: size,
        pda: publicAccess,
        regulatedData: regulated,
        sensitiveData: sensitivity,
        total: totalFilesCount,
      },
    });
    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
  } catch (err) {
    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
    console.error(err);
    redirectToLogin(err);
  }
}

function groupFileClassifications(data) {
  return Object.values(
    data.reduce((acc, row) => {
      const sensitivityId =
        row["FileClassificationStats.sensitivityId"];

      if (!acc[sensitivityId]) {
        acc[sensitivityId] = {
          sensitivityId,
          fileName: row["FileClassificationStats.fileName"],
          dataSourceId:
            row["FileClassificationStats.dataSourceId"],
          classifications: [],
        };
      }

      acc[sensitivityId].classifications.push(
        row["FileClassificationStats.classificationType"]
      );

      return acc;
    }, {})
  );
}


function* fetchSensitiveCardData(action) {
  yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: true });

  const cubejsApi = getCubejsApi();
  const dataSourceId = action.payload;

  const totalCount = {
    measures: ["DataTagSensitivity.count"],
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  const fileClassificationsStatus = {
    dimensions: ["FileClassificationStats.classificationCombination"],
    order: {
      "FileClassificationStats.fileCount": "desc",
    },
    measures: ["FileClassificationStats.fileCount"],
    filters: [
      {
        member: "FileClassificationStats.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  const sensitiveData = {
    measures: ["DataTagSensitivity.count"],
    dimensions: ["DataTagSensitivity.category"],
    order: {
      "DataTagSensitivity.count": "desc",
    },
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  try {
    const totalCountRes = yield cubejsApi.load(totalCount);
    const sensitiveRes = yield cubejsApi.load(sensitiveData);
    const fileClassificationRes = yield cubejsApi.load(
      fileClassificationsStatus
    );

    const groupedFileClassifications = fileClassificationRes.rawData()

    yield put({
      type: SET_SENSITIVE_SUMMARY_CARD_DATA,
      payload: {
        sensitiveData: sensitiveRes.rawData(),
        total: totalCountRes.rawData(),
        fileClassificationStatus: groupedFileClassifications,
      },
    });
    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
  } catch (err) {
    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
    console.error(err);
    redirectToLogin(err);
  }
}

function* fetchCategories(action) {
  yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: true });
  const cubejsApi = getCubejsApi();
  const dataSourceId = action.payload;
  const categories = {
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
    dimensions: ["DataTagSensitivity.finalType"],
    order: {
      "DataTagSensitivity.count": "desc",
    },
    measures: ["DataTagSensitivity.count"],
  };
  try {
    const resultSet = yield cubejsApi.load(categories);
    const result = resultSet.rawData();
    yield put({ type: SET_CATEGORY_CARD_DATA, payload: result });
    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
  } catch (error) {
    console.log(error);
    redirectToLogin(error);
  }
}

function* fetchAllFileTypesData(action) {
  const dataSourceId = action.payload
  const options = {
    method: "GET",
    url: fetchAllFileTypes(dataSourceId),
    headers: getAxiosHeaders(true)
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_ALL_FILE_TYPE_LIST,
        payload: res?.data || []
      })
    }

  } catch (err) {
    console.log(err);
    redirectToLogin(err)
  }
}

function* fetchDuplicateDriveSummary(action) {
  yield put({ type: SET_DATA_TAG_LOADING, payload: true });
  const { dataSourceId, page, size } = action.payload;
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateDriveDataAPI(dataSourceId, page, size),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_DRIVE_DATA,
        payload: res?.data?.content || [],
      });
      yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    redirectToLogin(err);
  }
}
  
function* fetchDuplicateUserData(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId, page, size, usernameFilter } = action.payload;
  console.log(usernameFilter,"fhjfh")
  let paramData = {};
  if (usernameFilter?.length) {
    paramData["duplicateActorId"] = usernameFilter
      .map((user) => user.id)
      .join(",");
  }
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateUserDataAPI(dataSourceId, actorId, page, size),
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_USER_DATA,
        payload: res?.data || [],
      })
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchDuplicateUserData_2(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId, page, size, duplicateActorId, directory } = action.payload;
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateUserDataAPI_2(dataSourceId, actorId, duplicateActorId, directory, page, size),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_USER_DATA_2,
        payload: res?.data || [],
      })
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchDuplicateDriveFileData(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId, page, size, sensitivity, fileNames } = action.payload;
  let paramData = {};
  let sensitivityFilter = "";
  let fileFilter = "";
  if (sensitivity && sensitivity.length > 0) {
    const mappedSensitivity = sensitivity.map((item) =>
      item === "NO_SENSITIVITY" ? "NOT_PROCESSED" : item,
    );

    sensitivityFilter = mappedSensitivity.join(",");
    paramData["sensitivities"] = sensitivityFilter;
  }
  if (fileNames && fileNames.length > 0) {
    fileFilter = fileNames.join(",");
    paramData["fileNames"] = fileFilter;
  }
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateDriveFileDataAPI(dataSourceId, actorId, page, size),
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA,
        payload: res?.data || [],
      })
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchFileMapData(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId } = action.payload;
  const options = {
    method: "GET",
    url: fileMapUrl(actorId, dataSourceId),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_FILE_MAP_DATA,
        payload: res?.data || [],
      })
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchDuplicateDriveFileData2(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, fileId, page, size } = action.payload;
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateDriveFileDataAPI_2(dataSourceId, fileId, page, size),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA_2,
        payload: res?.data || [],
      })
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* getUsersList(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId } = action.payload;
  const options = {
    method: "GET",
    url: userFilterList(dataSourceId, actorId),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_USERS_LIST,
        payload: res?.data || [],
      })
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchFileList(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId } = action.payload;
  const options = {
    method: "GET",
    url: fileFilterList(dataSourceId, actorId),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_FILES_LIST,
        payload: res?.data || [],
      })
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

/**
 * Watcher Saga
 */
function* DataTagDashboardSaga() {
  yield takeEvery(FETCH_DATA_TAG_DASHBOARD_DATA, getDataTagDashboardDataSaga);
  yield takeEvery(FETCH_DATA_TAG_ALL_FILES, fetchDataTagAllFiles);
  yield takeEvery(
    FETCH_ALL_DATA_SOURCES_API_DATA_TAG,
    fetchAllDataSourcesAPIDataTag
  );
  yield takeEvery(FETCH_DATA_TAG_USERS, fetchDataTagUsers);
  yield takeEvery(FETCH_DATA_TAG_DRIVES, fetchDataEstateDrives);
  yield takeEvery(FETCH_DATA_ESTATE_SUMMARY, fetchDataEstateSummary);
  yield takeEvery(FETCH_DATA_TAG_FILES, searchDataTagFiles);
  yield takeEvery(FETCH_DATA_TAG_USERS_LIST, searchDataTagUsers);
  yield takeEvery(FETCH_SIZE_CARD_DATA, fetchSizeCardData);
  yield takeEvery(FETCH_SENSITIVE_SUMMARY_CARD_DATA, fetchSensitiveCardData);
  yield takeEvery(FETCH_CATEGORY_CARD_DATA, fetchCategories);
  yield takeEvery(FETCH_ALL_FILE_TYPES_DATA, fetchAllFileTypesData);
  yield takeEvery(DATA_TAG_DUPLICATE_DRIVE_DATA, fetchDuplicateDriveSummary);
  yield takeEvery(DATA_TAG_DUPLICATE_USER_DATA, fetchDuplicateUserData);
  yield takeEvery(DATA_TAG_DUPLICATE_USER_DATA_2, fetchDuplicateUserData_2);
  yield takeEvery(DATA_TAG_DUPLICATE_FILE_DATA, fetchDuplicateDriveFileData);
  yield takeEvery(DATA_TAG_DUPLICATE_FILE_DATA_2, fetchDuplicateDriveFileData2);
  yield takeEvery(GET_FILE_MAP_DATA, fetchFileMapData);
  yield takeEvery(FETCH_USERS_LIST, getUsersList);
  yield takeEvery(FETCH_FILES_LIST, fetchFileList)
}

export default DataTagDashboardSaga;
